import store from 'services/store';
import { validateModel } from 'models/validate';
import legalSentenceValidator from 'forms/sections/legal/shared/sentence/sentence';
import { requireLegalOffenseSentenced, requireLegalOffenseIncarcerated } from 'helpers/branches';

const options = (formType) => ({
  requireLegalOffenseSentenced: requireLegalOffenseSentenced(formType),
  requireLegalOffenseIncarcerated: requireLegalOffenseIncarcerated(formType),
});

export const validateSentence = (data, formType) => validateModel(data, legalSentenceValidator, options(formType)) === true;

export default class SentenceValidator {
  constructor(data = {}) {
    const state = store.getState();
    const { formType } = state.application.Settings;
    this.data = data;
    this.formType = formType;
  }

  validChecks() {
    return (
      validateModel(
        this.data,
        {
          ExceedsYear: legalSentenceValidator.ExceedsYear,
          Incarcerated: legalSentenceValidator.Incarcerated,
        },
        options(this.formType)
      ) === true
    );
  }

  validIncarcerationDates() {
    return (
      validateModel(
        this.data,
        {
          IncarcerationDates: legalSentenceValidator.IncarcerationDates,
        },
        options(this.formType)
      ) === true
    );
  }

  validProbationDates() {
    return (
      validateModel(
        this.data,
        {
          ProbationDates: legalSentenceValidator.ProbationDates,
        },
        options(this.formType)
      ) === true
    );
  }

  isValid() {
    return validateSentence(this.data, this.formType);
  }
}
